import BookingsListPage from '../../shared/booking/BookingsListPage';

export default function SightseeingBookings() {
  return <BookingsListPage module="sightseeing" title="My activity bookings" />;
}
